import React, { useEffect, useState } from "react";
import { apiGet } from "../../../services/api";

interface SupplierRow {
  name: string;
  balance_due?: number;
}

interface AgeingRow {
  supplier: string;
  ageing?: { "0_30"?: number; "31_60"?: number; "61_plus"?: number };
  total_due: number;
}

export default function SupplierAgeing() {
  const [rows, setRows] = useState<AgeingRow[]>([]);

  const normalizeRow = (r: unknown): AgeingRow => {
    const row = (r ?? {}) as Record<string, unknown>;
    const supplier = String(row["supplier"] ?? row["name"] ?? "").trim() || "—";

    const ageingRaw = (row["ageing"] ?? {}) as Record<string, unknown>;
    const totalDueRaw = row["total_due"] ?? row["amount_due"] ?? row["balance_due"] ?? 0;

    const total_due = Number(totalDueRaw ?? 0) || 0;
    const a0 = Number(ageingRaw["0_30"] ?? (row["amount_due"] != null || row["balance_due"] != null ? total_due : 0)) || 0;
    const a31 = Number(ageingRaw["31_60"] ?? 0) || 0;
    const a61 = Number(ageingRaw["61_plus"] ?? 0) || 0;

    return {
      supplier,
      ageing: { "0_30": a0, "31_60": a31, "61_plus": a61 },
      total_due: Number(row["total_due"] ?? (a0 + a31 + a61) ?? total_due) || (a0 + a31 + a61),
    };
  };

  useEffect(() => {
    apiGet("/api/manager/supplier-ageing").then((data: unknown) => {
      const arr = Array.isArray(data) ? data.map(normalizeRow) : [];
      setRows(arr as AgeingRow[]);
    }).catch(err => {
      console.error("Failed to fetch supplier ageing:", err);
      // fallback or empty
      setRows([]);
    });
  }, []);

  return (
    <div className="card">
      <h3>⏳ Supplier Ageing</h3>

      <table className="records-table">
        <thead>
          <tr>
            <th>Supplier</th>
            <th>0–30</th>
            <th>31–60</th>
            <th>61+</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td>{r.supplier}</td>
              <td>₹{Number(r.ageing?.["0_30"] ?? 0)}</td>
              <td>₹{Number(r.ageing?.["31_60"] ?? 0)}</td>
              <td className="text-red">₹{Number(r.ageing?.["61_plus"] ?? 0)}</td>
              <td><strong>₹{r.total_due}</strong></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
